// environment settings that are used when the CI deploys to the dev environment
import { Environment } from './types';

export const environment: Environment = {
  production: false,
  name: 'dev',
  sentry: {
    enabled: true,
    showDialog: false,
  },
  sessionServer: 'soulmachines.cloud',
  deploymentSubdomains: [
    {
      name: 'Default',
      subdomain: 'playground',
    },
    {
      name: 'Azure',
      subdomain: 'playground.az',
    },
  ],
  apiConfig: {
    url: 'https://config-service-dev.soulmachines.cloud/api/v1',
  },
  apiOrg: {
    url: 'https://entity-service-dev.soulmachines.cloud/api/v1',
    urlV2: 'https://entity-service-dev.soulmachines.cloud/api/v2',
  },
  apiDesigner: {
    version: '2.4',
  },
  auth0Config: {
    audience: 'https://api.studio.soulmachines.cloud',
    domain: 'authenticate-studio-dev.soulmachines.cloud',
    clientId: 'CVIC7z4xxGWdK4j01chAJusPh9mfdd9u',
  },
  analytics: {
    url: 'https://analytics-service-dev.soulmachines.cloud/api/v1',
  },
  soulMachinesOrgId: 1,
  featureFlags: {
    'project-interactive-preview': true,
    'project-preview-speech-logging': false,
    'blender-stylized-mode': false,
    'insights-conversation-nodes': true,
    'manage-skills-form': true,
    'project-legal-agreements': false,
    'project-knowledge': true,
    'dashboard-conversation-count-usage-indicator': false,
    'navbar-organization-menu': true,
    'user-notification-receipt': false,
    'dashboard-usage-indicators': true,
    'admin-notification-contents': true,
    'project-sidebar-validation': true,
  },
  segment: {
    writeKey: '',
  },
  posthog: {
    apiKey: 'phc_njB6owfzxxJcs8oEU2rhNZFTpcaQ3yinyAVXVapZgQ26',
    apiHost: 'https://us.i.posthog.com',
    app_release: 'ddna-studio@dev',
  },
  projectThemes: [
    { text: 'auckland-sales-theme_dev', value: 'auckland-sales-theme_dev' },
    { text: 'auckland-sales-theme_prerelease', value: 'auckland-sales-theme_prerelease' },
    { text: 'auckland-sales-theme_stable', value: 'auckland-sales-theme_stable' },
  ],
  gtmId: 'GTM-PZQR4WX9',
};
